<script>
import UiBadge from '@/components/ui/Badge'

export default {
  name: 'DeviceMonitoringStatus',
  components: {
    UiBadge
  },
  props: {
    rmStatus: {
      type: String, Number,
      required: false
    },
    rmprocedures: {
      type: Array,
      required: false
    },
    isCompact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    procedure() {
      return !!this.rmprocedures && this.rmprocedures[0]
    },
    state() {
      if (this.rmStatus == null || this.rmStatus == 12) {
        return 'NOT_AVAILABLE'
      }
      if (!this.procedure) {
        return 'AVAILABLE'
      }
      if (this.procedure.pivot.status == 6) {
        return 'VERIFIED'
      }
      if (this.procedure.pivot.status == 5 && this.procedure.pivot.status_reason == null) {
        return 'WAITING'
      }
      return 'ERROR'
    },

    badge() {
      switch (this.state) {
        case 'AVAILABLE':
          return {
            icon: 'fa fa-bullhorn',
            type: 'secondary',
            label: window.V.$i18n.t('device.monitoring_status.available'),
          }
        case 'VERIFIED':
          return {
            icon:  'fa fa-check',
            type: 'success',
            label: window.V.$i18n.t('device.monitoring_status.verified'),
          }
        case 'WAITING':
          return {
            icon: 'fa fa-clock-o',
            type: 'info',
            label: window.V.$i18n.t('device.monitoring_status.waiting'),
          }
        case 'ERROR':
          return {
            icon: 'fa fa-exclamation-triangle',
            type: 'danger',
            label: window.V.$i18n.t('device.monitoring_status.failed'),
          }
      }
    },
    name() {
      return this.procedure?.name
    },
    link() {
      return !!this.procedure?.id
        ?
        {
          name: 'RemoteMonitoringShow',
          params: {
            id: this.procedure.id
          }
        }
        :
        {
          name: 'RemoteMonitoringList',
        }
    },
  }
}
</script>

<template>
  <div>
    <router-link 
      v-if="state !== 'NOT_AVAILABLE'"
      :to="link"
      class="d-inline-flex align-items-center flex-wrap gap-2"
    >
      <UiBadge :type="badge.type" :title="badge.label">
        <i :class="badge.icon" class="fa-lg"></i>
        <span v-if="!isCompact">{{ badge.label }}</span>
      </UiBadge>
      <span v-if="name && !isCompact">
        <i class="fa fa-bullhorn"></i>
        {{ name }}
      </span>
      <span v-if="!name && !isCompact" class="text-muted">
        {{$t('device.monitoring_status.no_procedure')}}
      </span>
    </router-link>
  </div>
</template>